import { Column } from 'devextreme-react/data-grid';
import { getCellFormat } from './utils/getCellFormat';

interface ReportColumnProps {
    column: any; // TODO: types, move to separate file 
    children?: React.ReactNode;
    allowGrouping?: boolean,
    allowSorting?: boolean,
    dateFormat?: string,
    groupCellContent?: any,
}

export function ReportColumn({ column, children, allowGrouping, allowSorting, dateFormat, groupCellContent }: Readonly<ReportColumnProps & { allowGrouping?: boolean; allowSorting?: boolean; dateFormat?: string }>): JSX.Element {
    return (
        <Column
            allowGrouping={allowGrouping}
            alignment="left"
            key={column.title}
            dataField={column.name}
            caption={column.title}
            allowSorting={allowSorting}
            dataType={column.type}
            format={getCellFormat(column.type, dateFormat)}
            width={column.width}
            groupIndex={column.groupIndex}
            groupCellRender={groupCellContent}
            visible={column.visible !== false} // default visible, unless explicitly set to false
        >
            {children}
        </Column>
    );
}
